import type {UserFacingEntity} from '../../../../../ui/core-entity/rows/peep-rows/types';

import type {CoreEntityConfirmationType, CoreEntityDialogProps} from './types';

export const getDialogPropsFromType = (
    type: CoreEntityConfirmationType,
    parentEntity: UserFacingEntity
): CoreEntityDialogProps => {
    const defaultProps: CoreEntityDialogProps = {
        question: `Are you sure you want to remove this ${type} from the ${parentEntity}?`,
        primaryText: 'Yes, remove',
        secondaryText: 'No, don’t remove',
        width: '240px',
    };

    switch (type) {
        case 'customField':
            return {
                question: 'Are you sure you want to clear this value?',
                primaryText: 'Yes, clear',
                secondaryText: 'No, don’t clear',
                width: '220px',
            };
        case 'association':
            return {
                question: 'Are you sure you want to remove this association?',
                primaryText: 'Yes, remove',
                secondaryText: 'No, don’t remove',
                width: '240px',
            };
        case 'audience':
            return {
                question: 'Are you sure you want to remove this person from the audience?',
                primaryText: 'Yes, remove',
                secondaryText: 'No, don’t remove',
                width: '240px',
            };
        default:
            return defaultProps;
    }
};
